var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{staticClass:"card-btn",class:[_vm.type && ("card-" + _vm.type)],on:{"click":_vm.click}},[_c('div',{staticClass:"card-btn__desc"},[_vm._t("desc")],2),_c('i',{class:_vm.icon})])}
var staticRenderFns = []

export { render, staticRenderFns }